export default "__VITE_ASSET__D4EuNXV5__"